<template>
    <div class="aboutus" id="aboutus">
       <app-header v-if="header_show"></app-header>
       <!-- 我的测评 -->
       <div class="content">
         <div class="curmbs">
           <span class="left" @click="toIndex">首页 > </span>
           <span class="left">关于我们 > </span>
           <span class="checked"> 正文</span>
         </div>
          <div class="article">
            <p class="title">关于第四届全国学生“学宪法 将宪法”活动网络海选投稿截止的通知</p>
            <p class="info"><span>发布时间：2019-10-16  09:15:17</span> <span>作者：本站编辑 </span> <span>来源：本站原创</span> <span>浏览次数：388619</span></p>
            <div class="detail">
              <p>
                由教育部主办，教育部全国青少年普法网（以下简称“普法网”）承办的第四届全国学生“学宪法 将宪法”活动网络海选于2019
                年9月正式启动。自开展以来，活动得到了全国各地师生的积极响应，形成了良好的宪法学习氛围。

              </p>
              <p>
                现就网络海选的相关安排进行通知：
              </p>
              <p>
                1.网络海选参赛作品上传通道已于2019年10月15日24时关闭，未能提交的作品已不能再提交。
                2.通过普法网上传通道上传的做皮哦你，第四届全国学生“学宪法 将宪法“活动组委会将统一进行审核。符合参赛要求/质量较高
                的作品将会在普法网网络海选页面上进行展示。
                3.通过审核的作品，将进入专家评审环节。根据专家评审结果，各组别成绩最优秀者将被选拔进入第四届全国学生”选宪法 讲宪法“
                活动全国总决赛。总决赛名单的公示时间未2019年11月上旬。
              </p>
              <p>
                第四届全国学生”学宪法 将宪法“活动组委会
              </p>
              <p>
                2019年10月16日
              </p>
            </div>
          </div>

       </div>
    </div>
</template>

<script>
  import Header from '@/components/Header'
  export default {
    name: 'aboutus',
    components: {
      'app-header':Header,
    },
    data () {
      return {
        header_show:true,
      }
    },
    watch: {

    },
    methods: {
      toIndex(){
        this.$router.push('index');
      },
    },

  }
</script>
<style scoped>
.content{
  width: 15rem;
  margin: 0 auto;
  padding-bottom: 0.84rem;
}
.content .curmbs{
  width: 100%;
  height: 1.03rem;
  line-height: 1.03rem;
  padding-left: 0.32rem;
}
.content .curmbs .left{
  float: left;
  font-size: 0.25rem;
  color: #404040;
  cursor: pointer;
}
.content .curmbs .checked{
  float: left;
  font-size: 0.25rem;
  color: #2b73cc;
}
.article{
  width: 12.08rem;
  margin: 0.6rem auto;
}
.article .title{
  font-size: 0.3rem;
  color: #323232;
}
.article .info{
  font-size: 0.21rem;
  color: #707070;
  margin: 0.3rem 0;
}
.article .info span{
  margin-right: 0.48rem;
}
.article .detail{
  font-size: 0.21rem;
  color: #323232;
}
.article .detail p{
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue